module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pwd-keyboard"
  }, [_c('w-row', {
    staticClass: "pwd-desc"
  }, [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("请输入6位交易密码")])], 1), _vm._v(" "), _c('w-row', {
    staticClass: "pwd-input-box",
    staticStyle: {
      "justify-content": "center"
    },
    attrs: {
      "align": "center",
      "height": 50
    }
  }, [_c('w-cell', {
    staticClass: "input-box-wrapper wui-border-1px",
    attrs: {
      "width": 300
    }
  }, _vm._l((6), function(i) {
    return _c('w-cell', {
      key: i,
      staticClass: "input-box",
      class: {
        'inputed': _vm.inputed && _vm.inputed[i - 1] >= 0
      },
      attrs: {
        "width": 50,
        "align": "center"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('w-row', {
    staticClass: "forgot-pwd",
    staticStyle: {
      "justify-content": "flex-end"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('w-cell', {
    attrs: {
      "width": 80
    }
  }, [_c('span', {
    staticClass: "forgot-pwd__button",
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("忘记密码?")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "keyboard-wrapper"
  }, [_c('number-keyboard', {
    on: {
      "input": _vm.handleInput
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-784201dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/components/pwd-keyboard.vue
// module id = 248
// module chunks = 93